module.exports = __webpack_public_path__ + "img/book.94e40ff6.png";